<div class="slp-card" *ngFor="let i of items" aria-hidden="true">

  <!-- header: wide title bar + small badge on the right -->
  <div class="slp-card__header">
    <div class="slp-shimmer slp-shimmer--title"></div>
    <div class="slp-shimmer slp-shimmer--badge"></div>
  </div>

  <!-- body: three columns mirroring the invoice / sa-card body grid -->
  <div class="slp-card__body">
    <div class="slp-card__column">
      <div class="slp-shimmer slp-shimmer--label"></div>
      <div class="slp-shimmer slp-shimmer--line"></div>
      <div class="slp-shimmer slp-shimmer--line slp-shimmer--line-short"></div>
    </div>
    <div class="slp-card__column">
      <div class="slp-shimmer slp-shimmer--label"></div>
      <div class="slp-shimmer slp-shimmer--line slp-shimmer--line-medium"></div>
      <div class="slp-shimmer slp-shimmer--line slp-shimmer--line-short"></div>
    </div>
    <div class="slp-card__column">
      <div class="slp-shimmer slp-shimmer--label"></div>
      <div class="slp-shimmer slp-shimmer--line"></div>
      <div class="slp-shimmer slp-shimmer--line slp-shimmer--line-medium"></div>
    </div>
  </div>

</div>
